<!-- ReviewModal.vue -->
<template>
  <Teleport to="body">
    <Transition name="dialog">
      <div
        v-if="modelValue"
        class="review_modal_overlay"
        @click.self="emit('update:modelValue', false)"
      >
        <div class="review_modal" :class="`review_modal_${size}`">
          <div class="review_modal_header">
            <p>{{ title }}</p>
            <button
              type="button"
              class="review_modal_close"
              @click="emit('update:modelValue', false)"
            >
              <i class="mdi mdi-close" />
            </button>
          </div>
          <slot />
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
defineProps<{
  title: string;
  size?: "sm" | "md";
}>();

const modelValue = defineModel<boolean>({ required: true });
const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
}>();
</script>